import { useQuery } from '@tanstack/react-query';
import type { FeatureCollection, LineString, Point } from 'geojson';
import type { z } from 'zod';
import type { schemaCreationAllee, schemaCreationRangee, schemaPositionPlace } from '@cc/contrats';
import { requete } from '../../api/client';

export interface Allee {
  id: string;
  code: string;
  nom: string;
  ligne: LineString;
  source: 'osm' | 'manuel';
  precision: 'schematique' | 'terrain';
}
export function useAllees(id: string) {
  return useQuery({
    queryKey: ['marches', id, 'allees'],
    queryFn: ({ signal }) =>
      requete<{ elements: Allee[] }>(`/marches/${id}/allees`, { signal }).then((r) => r.elements),
  });
}
export function usePlaces(id: string, bbox: [number, number, number, number] | null) {
  return useQuery({
    queryKey: ['marches', id, 'places', bbox],
    enabled: Boolean(bbox),
    retry: false,
    queryFn: ({ signal }) =>
      requete<FeatureCollection<Point>>(`/carte/marches/${id}/places`, {
        signal,
        parametres: { bbox: bbox!.join(',') },
      }),
  });
}
export const creerAllee = (id: string, corps: z.input<typeof schemaCreationAllee>) =>
  requete<Allee>(`/marches/${id}/allees`, { methode: 'POST', corps });
export const creerRangee = (
  id: string,
  allee: string,
  corps: z.input<typeof schemaCreationRangee>,
) =>
  requete<{ elements: { id: string; reference: string }[] }>(
    `/marches/${id}/allees/${allee}/rangee`,
    { methode: 'POST', corps },
  );
export const deplacerPlace = (id: string, corps: z.input<typeof schemaPositionPlace>) =>
  requete(`/marches/emplacements/${id}/position`, { methode: 'PATCH', corps });
